// export const wsUrl = 'ws://127.0.0.1:8765';
export const wsUrl = 'wss://async.sofiivka.uman.ua';